import { render } from "./index.vue?vue&type=template&id=89998f02&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=89998f02&lang=scss&scoped=true"
import "./index.vue?vue&type=style&index=1&id=89998f02&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-89998f02"]])

export default __exports__